import React from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { SEO } from "@/lib/seo";
import { Microscope, ScanSearch, FileDigit, Sparkles, Sofa, ShieldCheck } from "lucide-react";

// Exposed for site search indexer.
export const FEATURES = [
    { icon: Microscope, key: "f1" },
    { icon: ScanSearch, key: "f2" },
    { icon: FileDigit, key: "f3" },
    { icon: ShieldCheck, key: "f4" },
    { icon: Sofa, key: "f5" },
    { icon: Sparkles, key: "f6" },
];

export default function TechnologyPage() {
    const { t } = useTranslation();
    return (
        <>
            <SEO title={t("technology.seoTitle")} description={t("technology.seoDescription")} />
            <div className="container-page pt-8">
                <Breadcrumbs items={[{ label: t("technology.crumb") }]} />
            </div>
            <section className="container-page pt-6 pb-4">
                <div className="max-w-3xl">
                    <span className="chip-teal">{t("technology.chip")}</span>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--brand-navy)] leading-tight">
                        {t("technology.title")}
                    </h1>
                    <p className="mt-4 text-[color:var(--text-muted)] leading-relaxed text-lg">
                        {t("technology.intro")}
                    </p>
                </div>
            </section>
            <section className="container-page pb-6">
                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {FEATURES.map((feature) => (
                        <div key={feature.key} className="card-soft p-6">
                            <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-teal-soft)] text-[color:var(--brand-teal-2)]">
                                <feature.icon className="h-5 w-5" />
                            </div>
                            <h3 className="mt-4 font-display text-lg font-semibold text-[color:var(--brand-navy)]">{t(`technology.${feature.key}Title`)}</h3>
                            <p className="mt-2 text-sm text-[color:var(--text-muted)] leading-relaxed">{t(`technology.${feature.key}Body`)}</p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}
